export default __webpack_public_path__ + "static/media/youtube.88125348.png";